import * as React from 'react'
import { Button } from '../../../components/ui/button'
import { cn } from '../../../lib/utils'

/**
 * A write control that stays visible without `ingest/manage` but says why it
 * is disabled — a hidden button would leave the person guessing. Forwards its
 * ref so it can be a Radix trigger (`asChild`).
 */
export const WriteButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button> & { canManage: boolean }
>(function WriteButton({ canManage, ...props }, ref) {
  return (
    <Button
      {...props}
      ref={ref}
      disabled={!canManage || props.disabled}
      title={!canManage ? 'Needs the ingest/manage permission' : props.title}
      // Keep hover on the disabled button so its reason shows as a tooltip.
      className={cn(props.className, !canManage && 'disabled:pointer-events-auto')}
    />
  )
})
